/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getViewApplicationFlagsOverrides';

export type GetViewApplicationFlagsPathParams = NonNullable<
  operations['getViewApplicationFlags']['parameters']['path']
>;

export type GetViewApplicationFlagsQueryParams = NonNullable<
  operations['getViewApplicationFlags']['parameters']['query']
>;

export interface Input extends GetViewApplicationFlagsPathParams {
  apiVersion?: string;
  query?: GetViewApplicationFlagsQueryParams;
  header: NonNullable<operations['getViewApplicationFlags']['parameters']['header']>;
}

export async function getViewApplicationFlags(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/views/{viewKey}/application/flags', {
    params: { path, query, header },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
